// Tiny helper: capture and persist a ?ref=CODE on app load.
const REF_KEY = "studict_ref_code";

export function captureReferralFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      // Persist only the cleaned uppercase 6-char form
      const cleaned = String(ref).trim().toUpperCase().replace(/[^A-Z2-9]/g, "").slice(0, 6);
      if (cleaned.length === 6) {
        localStorage.setItem(REF_KEY, cleaned);
      }
    }
  } catch (_) { /* ignore */ }
}

export function getStoredReferralCode() {
  try { return localStorage.getItem(REF_KEY) || null; } catch (_) { return null; }
}

export function clearStoredReferralCode() {
  try { localStorage.removeItem(REF_KEY); } catch (_) { /* ignore */ }
}
